import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Logo from "../../components/Logo";

export const ContainerStyled = styled(Container)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
});

export const StyledGrid = styled(Grid)({
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

export const LogoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  flexDirection: "column",
  marginBottom: theme.spacing(3),
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.institutional.braskemGray,
}));

export const StyledLogo = styled(Logo)({
  height: "70px",
});
